import { render, staticRenderFns } from "./areaselect.vue?vue&type=template&id=477312fe&"
import script from "./areaselect.vue?vue&type=script&lang=js&"
export * from "./areaselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports